import { jsx as _jsx } from "react/jsx-runtime";
import BrandCard from '@/components/molecules/BrandCard/BrandCard';
import CardOffer from '@/components/molecules/CardOffer/CardOffer';
import FeaturedArticleCard from '@/components/molecules/FeaturedArticleCard/FeaturedArticleCard';
// Type guards for better type safety
export const isBrandContentType = (contentType) => {
    return contentType === 'BrandDetailPageModel' || contentType === 'FoodAndBeverageDetailPageModel';
};
export const isOfferContentType = (contentType) => {
    return contentType.includes('OfferDetail');
};
// Data mapping functions
export const mapBrandCardData = (dataObject) => ({
    name: dataObject.title || dataObject.brandName || dataObject.name || '',
    description: dataObject.brandDescription || dataObject.description,
    image: dataObject?.brandCardImage || dataObject?.image || dataObject?.media,
    logo: dataObject.brandLogo || dataObject.logo,
    path: dataObject.brandPath || dataObject.path || '#',
    tag: dataObject.brandTag || dataObject.tag,
    categories: dataObject.brandCategories || dataObject.categories,
    specialOffers: dataObject.specialOffers,
    componentID: dataObject.componentID,
    contentTypeId: dataObject.contentTypeId,
});
export const mapOfferCardData = (dataObject) => ({
    title: dataObject.title || '',
    subTitle: dataObject.subTitle || dataObject.subtitle,
    media: dataObject.media || dataObject.image,
    tag: dataObject.tag,
    expiringIn: dataObject.expiringIn || dataObject.expiry,
    brand: dataObject.brand || dataObject.brandName,
    path: dataObject.path || '#',
    logo: dataObject.logo || dataObject.brandLogo,
    categories: dataObject.categories || [],
    moreOffers: dataObject.moreOffers,
    outletPriceLabel: dataObject.outletPriceLabel,
    outletPriceValue: dataObject.outletPriceValue,
    rrpPriceLabel: dataObject.rrpPriceLabel,
    rrpPriceValue: dataObject.rrpPriceValue,
    brandPath: dataObject.brandPath,
    preTitle: dataObject.preTitle,
    className: dataObject.className,
    headingLevel: dataObject.headingLevel || 'h3',
    componentID: dataObject.componentID,
    contentTypeId: dataObject.contentTypeId,
});
export const SearchCard = ({ item, contentType, testid, accessibilityProps, saveLabel, removeLabel, cookieName, defaultSaveIcon, activeSaveIcon, saveItemEndpoint, index = 0, parentComponentName, onSaveSuccess, }) => {
    const { dataObject } = item;
    if (isBrandContentType(contentType)) {
        const card = mapBrandCardData(dataObject);
        return (_jsx("div", { className: "h-full", "data-testid": testid, children: _jsx(BrandCard, { card: card, layout: "VerticalWide", index: index, showDescriptionOnDesktop: true, parentComponent: parentComponentName ?? 'Search', parentColumnCountMd: 4, saveLabel: saveLabel, removeLabel: removeLabel, cookieName: cookieName, defaultSaveIcon: defaultSaveIcon, activeSaveIcon: activeSaveIcon, saveItemEndpoint: saveItemEndpoint, accessibilityProps: accessibilityProps, className: "h-full", onSaveSuccess: onSaveSuccess }) }));
    }
    if (isOfferContentType(contentType)) {
        const offerProps = mapOfferCardData(dataObject);
        return (_jsx("div", { className: "h-full", "data-testid": testid, children: _jsx(CardOffer, { ...offerProps, saveLabel: saveLabel, removeLabel: removeLabel, cookieName: cookieName, saveIcon: defaultSaveIcon, activeSaveIcon: activeSaveIcon, saveItemEndpoint: saveItemEndpoint, parentComponent: "Offer Listing", className: "h-full", fullHeight: true, onSaveSuccess: onSaveSuccess }) }));
    }
    return (_jsx("div", { className: "h-full", "data-testid": testid, children: _jsx(FeaturedArticleCard, { card: {
                ...dataObject,
            }, saveLabel: saveLabel, removeLabel: removeLabel, cookieName: cookieName, defaultSaveIcon: defaultSaveIcon, activeSaveIcon: activeSaveIcon, saveItemEndpoint: saveItemEndpoint, parentComponent: parentComponentName, accessibilityProps: accessibilityProps, className: "h-full", onSaveSuccess: onSaveSuccess }) }));
};
